import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { Button } from 'ui-widgets';
import topBannerStyles from './TopBannersWrapper.module.scss';
import { CampaignBanner } from '../../components/CampaignBanner';
import { definedTranslation } from '../../i18n';
import { campaignTopBannerSelector } from '../../redux/selectors/searchSelector';

const TopBannersWrapper = () => {
  const campaignTopBanner = useSelector(campaignTopBannerSelector);
  const isBanner = campaignTopBanner != null;
  const intl = useIntl();
  const from = new URLSearchParams(window.location.search).get('from');

  return (
    // Bring back height: 260px of container div, if A1 or Collections will be added back for CLS
    <div>
      {from && (
        <Button
          variant="outlined"
          startIcon="back"
          href={from}
          classes={{ root: topBannerStyles.backButton }}
        >
          {intl.formatMessage(definedTranslation.topBanners.backButton)}
        </Button>
      )}
      {isBanner && <CampaignBanner {...campaignTopBanner} />}
    </div>
  );
};

export default TopBannersWrapper;
